import React from "react";
import { useNavigate } from "react-router-dom";
import MainMenuItem from "app/components/MainMenuItem";
import Path from "app/route/Path";

function SalonManagementCreateNoticeMenuItem(props) {
  const navigate = useNavigate();

  const onMenuItemClicked = () => {
    navigate(Path.salon.manage.article(0));
  };

  return (
    <MainMenuItem
      itemTitleString="記事を登録する"
      onClick={onMenuItemClicked}
      size="100%"
    />
  );
}

export default SalonManagementCreateNoticeMenuItem;
